<div class="modal-wrapper">
  <div class="modal-header">
    <h1 class="modal-title">Notifications</h1>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <i class="ic-close"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="notification-section-header" *ngIf="recent?.length > 0">
      <p class="title-section">Recents</p>
      <button class="mark-all btn btn-action" (click)="markAllNotificationAsRead()">Mark all as read</button>
    </div>
    <app-notifications-card-item [notificationList]="recent"></app-notifications-card-item>
    <div class="notification-section-header notification-earlier" *ngIf="older?.length > 0">
      <p class="title-section">Earlier</p>
      <button class="mark-all btn btn-action" (click)="markAllNotificationAsRead()" *ngIf="recent?.length === 0">Mark all as read</button>
    </div>
    <app-notifications-card-item [notificationList]="older"></app-notifications-card-item>
  </div>
  <div class="modal-footer">
    <button (click)='goToProfileNotifications()' class="btn settings-link">
      <i class="ic-settings"></i>
    </button>
  </div>
</div>
